import {SellerError} from './SellerError.js'

export class GetInstantOfferGenericSellerError extends SellerError {}
